import theme from '@styles/theme';
export default {
  section: (blocks: number, singleSliderHeight: number) => ({
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    // height: `${blocks * 100}vh`,
    height: `calc(100vh + ${blocks * singleSliderHeight}px)`,
    width: '100%',
    backgroundColor: 'lightGreyBg2'
  }),
  mobileSection: {
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    width: '100%',
    backgroundColor: 'lightGreyBg2'
  },
  container: (height: number, marginTop: number) => ({
    position: 'sticky',
    top: `${marginTop}px`,
    left: '0',
    // Avoid height: 0px before viewport is measured — picture/img use height: 100%.
    height: height > 0 ? `${height}px` : '100vh',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden'
  }),
  mobileContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '100%'
  }
};